/**
 * Date utility functions for consistent date formatting across the application
 */

/**
 * Formats a date to "dd-Month-yyyy" format (e.g., "15-September-2025")
 * @param {Date|string} date - The date to format
 * @returns {string} - Formatted date string
 */
export const formatDateToWords = (date) => {
  if (!date) return '';
  
  const dateObj = new Date(date);
  
  // Check if date is valid
  if (isNaN(dateObj.getTime())) return '';
  
  const day = dateObj.getDate().toString().padStart(2, '0');
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  const month = monthNames[dateObj.getMonth()];
  const year = dateObj.getFullYear();
  
  return `${day}-${month}-${year}`;
};

/**
 * Formats a date for DatePicker display (dd/MM/yyyy format for input but will be displayed consistently)
 * @returns {string} - DatePicker format string
 */
export const getDatePickerFormat = () => {
  // Using dd/MM/yyyy for DatePicker input, but we'll handle display format separately
  return "dd/MM/yyyy";
};

// Parse a value into a valid Date, or null if it can't be parsed.
// react-datepicker's `selected` prop crashes with "Invalid time value" when it
// receives a Date whose getTime() is NaN (e.g. from `new Date(undefined)`).
// Passing null instead renders an empty input, which is the correct "unset" UX.
export const safeParseDate = (value) => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return isNaN(d.getTime()) ? null : d;
};
